import React from 'react';
import logo from './logo.png';
import './App.css';
import SEO from './components/SEO';
import { generateBreadcrumbSchema } from './utils/structuredData';

export default function AboutArabic() {
  // Breadcrumb structured data
  const breadcrumbs = [
    { name: 'الرئيسية', url: '/' },
    { name: 'معلومات عنا', url: '/about-ar' }
  ];

  return (
    <section dir="rtl" style={{ background: '#FDF8EE', minHeight: '100vh', padding: '6vw 0 4vw 0', display: 'flex', flexDirection: 'column', alignItems: 'center', fontFamily: "'IBM Plex Sans Arabic', sans-serif" }}>
      {/* SEO Meta Tags */}
      <SEO
        title="عن تعلّم - قصتنا ورسالتنا"
        description="تعرف على تعلّم، التي أسسها عبدالله هلال والسيد محمد لربط الطلاب بالمعلمين المؤهلين في البحرين. اكتشف مهمتنا لإحداث ثورة في التعليم."
        keywords="عن تعلّم, منصة تعليمية البحرين, قصة التعلم الإلكتروني, مؤسسو منصة الدروس, عبدالله هلال, السيد محمد"
        canonicalUrl="/about-ar"
        alternateUrls={{ en: '/about', ar: '/about-ar' }}
        lang="ar"
        structuredData={generateBreadcrumbSchema(breadcrumbs)}
      />

      <div style={{ maxWidth: 800, width: '100%', maxWidth: '95vw', margin: '0 auto', background: '#fff', borderRadius: 24, boxShadow: '0 4px 24px #e0eaff', padding: '6vw 4vw', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <img src={logo} alt="شعار تعلّم" style={{ width: 70, marginBottom: 20, maxWidth: '30vw' }} />
        <h1 style={{ fontSize: '2.1rem', fontWeight: 700, color: '#0F2545', marginBottom: 12, textAlign: 'center', fontFamily: "'IBM Plex Sans Arabic', sans-serif" }}>معلومات عناً</h1>
        <p style={{ color: '#888', fontSize: '1rem', textAlign: 'center', marginBottom: 24, maxWidth: 700, fontFamily: "'IBM Plex Sans Arabic', sans-serif" }}>
          تعلّم هي منصة تعليمية أسسها عبدالله هلال وشارك في تأسيسها السيد محمد. جاءت فكرة المنصة بعد معاناة شخصية في إيجاد معلمين مؤهلين وموثوقين لمساعدتنا في بعض المواد الدراسية. هذه التجربة دفعتنا لتأسيس حل يُسهل على الطلاب الوصول إلى الدعم التعليمي المناسب بكل سهولة.
        </p>
        <div style={{ width: '100%', borderTop: '1.5px solid #e0eaff', margin: '24px 0' }} />
        <p style={{ color: '#232B3E', fontSize: '0.98rem', textAlign: 'center', marginBottom: 18, maxWidth: 700, fontFamily: "'IBM Plex Sans Arabic', sans-serif" }}>
          تعمل المنصة على ربط الطلاب بالمعلمين بطريقة سلسة ومنظمة. يمكن للطالب الاطلاع على ملف المعلم، ومعرفة الأوقات المتاحة، وحجز الدروس مباشرة بطريقة تضمن تجربة تعليمية شخصية وأكثر كفاءة. كما يتم توفير نظام دردشة مدمج يضمن التواصل السهل والآمن بين الطرفين.
        </p>
        <p style={{ color: '#232B3E', fontSize: '0.98rem', textAlign: 'center', marginBottom: 18, maxWidth: 700, fontFamily: "'IBM Plex Sans Arabic', sans-serif" }}>
          أطلقنا تعلّم لخدمة المجتمع المحلي في البحرين، مع التركيز على بناء الثقة والجودة في التعليم الإلكتروني. يتم مراجعة جميع المعلمين بدقة، وقد صممنا المنصة لتكون بسيطة وسهلة الاستخدام لجميع المستخدمين.
        </p>
        <p style={{ color: '#232B3E', fontSize: '0.98rem', textAlign: 'center', marginBottom: 18, maxWidth: 700, fontFamily: "'IBM Plex Sans Arabic', sans-serif" }}>
          هدفنا هو تطوير منصة تعلّم بشكل مستمر وتوسيع خدماتها لتشمل منطقة الخليج ثم الوصول إلى السوق العالمية. نطمح لأن نصبح اسمًا موثوقًا في مجال التقنية التعليمية، ونجعل من السهل على كل متعلم أن يجد المعلم المناسب له في أي وقت ومن أي مكان.
        </p>
      </div>
    </section>
  );
} 